
import { useQuery } from "@tanstack/react-query";
import { api } from '@/shared/api/endpoints';

import { IGetAllUsersFinancialResponse } from '@/shared/types';

export function useAdminStats(search: string, page: number, status: string) {
    return useQuery<IGetAllUsersFinancialResponse>({
        queryKey: ["adminStats", search, page, status],
        queryFn: async () => {
            const res = await api.admin.getDashboardStats({ search, page, status });
            if (!res.success || !res.data) {
                throw new Error("Failed to fetch stats");
            }
            return res.data as IGetAllUsersFinancialResponse;
        },
        placeholderData: (prevData) => prevData,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
    });
}




